import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24.5 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m23.707 22.297-6.825-6.825a9.518 9.518 0 1 0-1.414 1.414l6.825 6.825a1 1 0 1 0 1.414-1.414ZM9.5 16.997a7.5 7.5 0 1 1 7.5-7.5 7.508 7.508 0 0 1-7.5 7.5Z"
    }, null, -1)
  ])))
}
export default { render: render }